import { McTag } from "@maersk-global/mds-react-wrapper/components-core/mc-tag";
import {
  calculateTimeDifference,
  convertMinutesToTime,
  formatDateAndTime,
  formatStatus,
  formatTimeToAvailableValues,
  getOutcomeClass,
  renderWithTooltip,
} from "../../../utils/helper";
import "./custom-table.scss";
import { APPROVED_REJECTED_CASES } from "../../../constants/constants";

export const renderBlNumber = (row) => {
  const { blnumber = [] } = row;
  return renderWithTooltip(blnumber);
};

export const renderCustomerName = (row) => {
  const { customername = "" } = row;
  return renderWithTooltip(customername);
};

export const renderCaseStatusReason = (row) => {
  const { casestatusreason = "" } = row;
  return renderWithTooltip(casestatusreason, 1, true);
};

export const renderDate = (row, header) =>
  row[header.key] && formatDateAndTime(row[header.key]);

export const renderTimeInhour = (row, header) =>
  row[header.key] && convertMinutesToTime(row[header.key]);

export const renderCaseStatus = (row) => {
  const { casestatus } = row;
  return (
    <div>
      <div className={casestatus}>
        {casestatus && <McTag fit="small">{formatStatus(casestatus)}</McTag>}
      </div>
    </div>
  );
};

export const renderSlaStatus = (row) => {
  const { slastatus } = row;
  return (
    <div>
      <div className={slastatus}>
        {slastatus && <McTag fit="small">{formatStatus(slastatus)}</McTag>}
      </div>
    </div>
  );
};

export const renderdacaseprocessingtime = (row) => {
  const { casestatusdatetime = "", createddate = "" } = row;
  return formatTimeToAvailableValues(
    calculateTimeDifference(casestatusdatetime, createddate)
  );
};

export const renderSlaRemainingTime = (row) => {
  const { slastatus, casestatus, slaremainingtime } = row;
  return slastatus === "SLA-MET" || APPROVED_REJECTED_CASES.includes(casestatus)
    ? " "
    : convertMinutesToTime(slaremainingtime).replace(/0 m/g, " ");
};

export const renderCaseRespondedAt = (row, header) => {
  const { casestatus } = row;
  return APPROVED_REJECTED_CASES.includes(casestatus)
    ? renderDate(row, header)
    : " ";
};

export const renderCaseTat = (row) => {
  const { casestatus, casetat } = row;
  return APPROVED_REJECTED_CASES.includes(casestatus)
    ? formatTimeToAvailableValues(casetat)
    : " ";
};

export const renderOutcome = (row) => {
  const { outcome } = row;
  return (
    <div>
      <div className={getOutcomeClass(outcome)}>
        <McTag fit="small">{outcome}</McTag>
      </div>
    </div>
  );
};

export const renderTargetSla = (row) => {
  return " ";
};
